import {AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {UntilDestroy} from '@ngneat/until-destroy';
import { FilterSelectFieldConfig } from '../filter-select-field.config';
import { SelectItem } from '../../select/select-item';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { FieldConfigWrapper } from '../../../dynamic-field/field-config-wrapper';


@UntilDestroy()
@Component({
  selector: 'mydocma-filter-select-dropdown',
  templateUrl: './filter-select-dropdown.component.html',
  styleUrls: ['./filter-select-dropdown.component.scss']
})
export class FilterSelectDropdownComponent implements OnInit,OnDestroy {


  formGroup: UntypedFormGroup;

  public customSearchFunc = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: {fieldWrapper: FieldConfigWrapper<FilterSelectFieldConfig>, selectedItem: SelectItem},
    private readonly dialogRef: MatDialogRef<FilterSelectDropdownComponent>) {

      const formControlConfig = {};
      formControlConfig[this.dialogData.fieldWrapper.config.name] = new UntypedFormControl();
      this.formGroup = new UntypedFormGroup(formControlConfig);
      this.formGroup.controls[this.dialogData.fieldWrapper.config.name].setValue(this.dialogData.selectedItem);

    }

  ngOnInit() {
    this.customSearchFunc = this.dialogData.fieldWrapper.config?.customSearch
    ? this.dialogData.fieldWrapper.config?.customSearch.bind(this) : this.defaultSearch;
  }

  ngOnDestroy(): void {}


  selectItem(item: SelectItem) {
    if(item) {
      this.dialogRef.close(item)
    } else {
      this.formGroup.controls[this.dialogData.fieldWrapper.config.name].setValue(this.dialogData.selectedItem);
    };
  }

  async close() {
    this.dialogRef.close(null);
  }


  public addTag(tag: string): any {
    if (!this.dialogData.fieldWrapper.config?.onItemAdded) {
        return tag;
    }
    return this.dialogData.fieldWrapper.config?.onItemAdded({
        value: tag,
    });
  }

  defaultSearch(term: string, item: any) {
    term = term.toLocaleLowerCase().trimEnd();
    return item.text?.toLocaleLowerCase()?.indexOf(term) > -1;                
  };

}
